import './App.css';
import React, { lazy, Suspense, useEffect } from 'react';
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import { routerPaths } from './utils/routes';
import './fonts/fonts.css';
import { ExternalDynamicLinks } from './helpers/urlHelper';

// Lazy-loaded routes
const Signin = lazy(() => import('./pages/Signin/SignIn'));
const EmailVerification = lazy(() => import('./pages/Signup/flow/EmailVerification'));
const MobileVerification = lazy(() => import('./pages/Signup/flow/MobileVerification'));
const SplashScreen = lazy(() => import('./pages/Signup/flow/SplashScreen'));
const EnterMobileNumber = lazy(() => import('./pages/Signup/flow/EnterMobileNumber'));
const MainComponent = lazy(() => import('./pages/Signup/flow/MainComponent'));
const ForgotPassword = lazy(() => import('./pages/Forgot-password/flow/ForgotPassword'));
const EmailSent = lazy(() => import('./pages/Forgot-password/flow/EmailSent'));
const EnterOTP = lazy(() => import('./pages/Forgot-password/flow/EnterOTP'));
const SetNewPassword = lazy(() => import('./pages/Forgot-password/flow/SetNewPassword'));
const ReRegistration = lazy(() => import('./pages/Re-Registration/ReRegistration'));
const ReRegistrationApproved = lazy(() => import('./pages/Re-Registration/ReRegjstrationApproved'));
const TermAndConditions = lazy(() => import('./pages/TermAndConditions/TermAndConditions'));
const LegalPrivacyPolicy = lazy(() => import('./pages/LegalPrivacyPolicy/LegalPrivacyPolicy'));
const Home = lazy(() => import('./pages/Home/Home'));
const DownloadPage = lazy(() => import('./pages/DownloadPage/DownloadPage'));
const AllowRegister = lazy(() => import('./pages/AllowRegister/AllowRegister'));

// Suspense wrapper
const lazyElement = (Component) => ({
  element: (
    <Suspense fallback={<div />}>
      <Component />
    </Suspense>
  )
});

const router = createBrowserRouter([
  {
    path: routerPaths.SIGN_IN,
    ...lazyElement(Signin)
  },
  {
    path: routerPaths.SIGN_UP,
    ...lazyElement(MainComponent)
  },
  {
    path: routerPaths.EMAIL_VERIFICATION,
    ...lazyElement(EmailVerification)
  },
  {
    path: routerPaths.ENTER_MOBILE_NUMBER,
    ...lazyElement(EnterMobileNumber)
  },
  {
    path: routerPaths.MOBILE_VERIFICATION,
    ...lazyElement(MobileVerification)
  },
  {
    path: routerPaths.SIGNUP_SPLASH_SCREEN,
    ...lazyElement(SplashScreen)
  },
  {
    path: routerPaths.FORGOT_PASSWORD_ENTER_EMAIL,
    ...lazyElement(ForgotPassword)
  },
  {
    path: routerPaths.FORGOT_PASSWORD_EMAIL_SENT,
    ...lazyElement(EmailSent)
  },
  {
    path: routerPaths.FORGOT_PASSWORD_ENTER_OTP,
    ...lazyElement(EnterOTP)
  },
  {
    path: routerPaths.FORGOT_PASSWORD_SET_NEW_PASSWORD,
    ...lazyElement(SetNewPassword)
  },
  {
    path: routerPaths.DOWNLOAD,
    ...lazyElement(DownloadPage)
  },
  {
    path: routerPaths.HOME,
    ...lazyElement(Home)
  },
  {
    path: routerPaths.ALLOW_REGISTER,
    ...lazyElement(AllowRegister)
  },
  {
    path: routerPaths.Re_REGISTRATION,
    ...lazyElement(ReRegistration)
  },
  {
    path: routerPaths.Re_REGISTRATIONAPPROVED,
    ...lazyElement(ReRegistrationApproved)
  },
  {
    path: routerPaths.TERM_AND_CONDITIONS,
    ...lazyElement(TermAndConditions)
  },
  {
    path: routerPaths.LEGAL_PRIVACY_POLICY,
    ...lazyElement(LegalPrivacyPolicy)
  },
  {
    path: '*',
    element: <Navigate to={routerPaths.SIGN_UP} replace />
  }
]);

function App() {
  useEffect(() => {
    const allowedOrigins = [ExternalDynamicLinks.dashboard()];

    const handleMessageFromSignupWeb = (event) => {
      if (allowedOrigins.includes(event.origin)) {
        const data = event.data;
        if (data) {
          const msgData = JSON.parse(data);
          const ownershipuid = msgData?.ownershipuid;
          const hashKey = msgData?.hashKey;

          localStorage.setItem('ownership_uid', ownershipuid);
          localStorage.setItem('hash_key', hashKey);
        }
      }
    };

    window.addEventListener('message', handleMessageFromSignupWeb, false);
    return () => window.removeEventListener('message', handleMessageFromSignupWeb);
  }, []);

  return <RouterProvider router={router} />;
}

export default App;
